import { getGroupFullInfo } from '@/api';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

type UseSelectedSystemOptions = {
  onError?: () => void;
};

const defaultOptions = {
  onError: () => undefined,
} satisfies UseSelectedSystemOptions;

export const useSelectedSystem = (systemId: string, options?: UseSelectedSystemOptions) => {
  const { onError = defaultOptions.onError } = options || {};
  const { data, error, isLoading } = useQuery({
    queryKey: ['selectedSystem', systemId],
    queryFn: async () => {
      if (!systemId) return null;

      try {
        const response = await getGroupFullInfo(systemId);
        return response.data;
      } catch (err: unknown) {
        if (axios.isAxiosError(err)) {
          if (err.response?.status == 403) {
            onError?.();
            return null;
          }

          return null;
        }

        if (error) throw err;

        return null;
      }
    },
    retry: false,
    enabled: !!systemId,
  });

  const isForbidden = Boolean(error && axios.isAxiosError(error) && error.response?.status == 403);

  const selectedSystem = data || null;

  return { selectedSystem, error, isLoading, isForbidden };
};
